import Vue from 'vue';

export default  {
    state:{
        user:{
            avatar:"",
            info:{
                name:"",
                surname:""
            },
            email:"",
            groups:[]
        }
    },
    getters:{
        user(state){
            return ()=>{
                return state.user;
            };
        }
    },
    actions:{
        loadProfile({context, state}){
            Vue.http.get("profile/info").then((res) => {
                if (res.body.profile._id.length > 0) {
                    state.user = res.body.profile;
                } else {
                    state.user.isEmpty = true;
                }
            })
        },
        saveInfo({context, state},info) {
            Vue.http.post('profile/info',{info}).then((res)=>{
               state.user.info = Object.assign({},state.user.info, info);
            });
        },
        savePhone({context, state},phone){
            Vue.http.post('profile/phone/change',{new_phone}).then((res)=>{
               
            });
        },
        changeAvatar() {
        },
        changeProfile() {
            let profile = {
                name: this.name,
                surname: this.surname
            };
            this.$http.post("profile/info", profile).then((res) => {
                console.log("Answer", res.body);
            }, (error) => {
                console.log("We have error here", error);
            });
        },
        changeEmail() {
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (re.test(this.email)) {
                let emailChange = {
                    new_email: this.email
                };

                this.$http.post("profile/email/change", emailChange).then((res) => {
                    if (res.body.error.message == undefined) {
                        alert("Подтвердите изменения на почте")
                    }
                    if (res.body.error.message == "EMAIL_INVALID_FORMAT") {
                        alert("Формат введенного адреса неправильный")
                    }
                    console.log("Answer", res.body)
                }, (error) => {
                    console.log("We have error here", error)
                })
            }
            else {
                alert("Вы ввели электронный адрес некорректно. Попробуйте еще раз")
            }


        },
        changePassword() {

            let passChange = {
                old_password: this.password,
                new_password: this.newPassword,
                confirm_password: this.newPasswordRepeat
            };

            this.$http.post("profile/password/change", passChange).then((res) => {
                if (res.body.error) {
                    let error_codes = {
                        NEW_PASSWORD_EQUALS_OLD: "Новый пароль не должен совпадать с старым паролем",
                        YOU_DID_NOT_CONFIRM_PASSWORD: "Повторно введенный пароль не совпадает",
                        NEW_PASSWORD_IS_TO0_WEAK: "Пароль должен содержать прописные и строчные буквы"
                    };
                    let msg = error_codes[res.body.error.message];
                    alert(msg || "Undefined Error");
                }
                console.log("Answer", res.body)
            }, (error) => {
                console.log("We have error here", error)
            })

        },
    }
}